<template>
  <nav class="d-lg-inline-block d-none main-menu navbar-expand fontsize13">
    <b-row id="menuSkelton" v-if="status">
      <b-skeleton
        height="25px"
        width="65px"
        class="mr-3"
        type="input"
      ></b-skeleton>
      <b-skeleton
        height="25px"
        width="65px"
        class="mr-3"
        type="input"
      ></b-skeleton>
      <b-skeleton
        height="25px"
        width="65px"
        class="mr-3"
        type="input"
      ></b-skeleton>
      <b-skeleton height="25px" width="65px" class="mr-3" type="input"
        >ّ</b-skeleton
      >
      <b-skeleton
        height="25px"
        width="65px"
        class="mr-3"
        type="input"
      ></b-skeleton>
    </b-row>
    <ul class="navbar-nav h-100 pt-2 mr-3">
      <li
        v-for="item in menu"
        :key="item.id"
        :class="{ 'has-children': item.children.length != 0 }"
        class="nav-item"
      >
        <router-link
          class="nav-link d-inline-block font-weight-bold"
          :to="findUrl(item.linkable_type, item.linkable_id, item.slug)"
        >
          {{ item.title }}
          <span v-if="item.children.length != 0">
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 8.5L12 15.5L5 8.5"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </router-link>
        <ul
          v-if="item.children.length != 0"
          class="dropdown-menu-hover list-unstyled text-center bg-white"
        >
        
          <li     v-for="childMenu in item.children"
              :key="childMenu.id" class="nav-item">
            <router-link
              class="nav-link"
          
               :to="
                findUrl(
                  childMenu.linkable_type,
                  childMenu.linkable_id,
                  childMenu.slug
                )"
              >{{ childMenu.title }}</router-link
            >
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import findUrl from "@/libraries/links/LinkResolver";

export default {
  name: "Nav",
  computed: {
    menu() {
      if (this.$store.getters["front/getHomeData"] != null) {
        return this.$store.getters["front/getHomeData"].menu.header;
      } else {
        return this.$store.getters["front/getHomeData"];
      }
    },
    status() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
  },
  methods: {
    findUrl,
  },
};
</script>

<style scoped>

#menuSkelton {
  display: flex;
  justify-content: space-around;
}
</style>
